import type { GlbSceneConfig } from '../glb/glbSceneConfig';
import { resolveCdnUrl } from '../../utils/cdnUrl';

export const blackStoneSceneConfig: GlbSceneConfig = {
  id: 'black-stone-scene',
  bgTheme: 'white',
  renderer: {
    maxPixelRatio: 2,
  },
  camera: {
    fov: 60,
    near: 0.01,
    far: 100,
    initialPosition: {"x":8.5917,"y":-0.3957,"z":16.3238},
    initialTarget: { x: 0, y: 0, z: 0 },
  },
  controls: {
    target: { x: 0, y: 0, z: 0 },
    minDistance: 5, // нельзя приблизиться слишком близко к модели
    maxDistance: 20, // нельзя сильно отдалиться
    enablePan: false,
    minPolarAngle: 0.3, // ~17° — нельзя смотреть строго сверху
    maxPolarAngle: Math.PI * 0.55, // ~99° — нельзя заглянуть снизу
    minAzimuthAngle: -Math.PI / 3, // -60° от начального направления камеры
    maxAzimuthAngle: Math.PI / 3, // +60° от начального направления камеры
    enableDamping: true,
    dampingFactor: 0.08,
  },
  models: [
    {
      key: 'black-stone-scene',
      url: resolveCdnUrl('models/poi-artifacts/stone_polished_gold_ring_v2.glb'),
    },
  ],
  environment: {
    hemisphereLight: {
      skyColor: 0xffffff,
      groundColor: 0x444444,
      intensity: 0.8,
    },
    directionalLights: [
      {
        color: 0xffffff,
        intensity: 1.2,
        position: { x: 2, y: 3, z: 2 },
      },
      {
        color: 0xffd700,
        intensity: 0.4,
        position: { x: -1, y: 1, z: -2 },
      },
    ],
  },
  collision: {
    cameraRadius: 0.3,
  },
};
